import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-customer-payment-modal',
	templateUrl: './customer-payment-modal.component.html',
	styleUrls: ['./customer-payment-modal.component.scss'],
})
export class CustomerPaymentModalComponent implements OnInit {
	debtorno = '';
	branchcode = '';
	customerTitle = '';

	/** Minimal stub so `PaymentComponent` `loadCustomer()` can run. */
	customerForPayment: { debtorno: string; branchcode: string; name: string } | null = null;

	constructor(public activeModal: NgbActiveModal) {}

	ngOnInit(): void {
		const d = this.debtorno?.trim() ?? '';
		const b = this.branchcode?.trim() ?? '';
		if (!d || !b) {
			return;
		}
		this.customerForPayment = {
			debtorno: d,
			branchcode: b,
			name: this.customerTitle?.trim() ?? '',
		};
	}
}
